import api from './api';

export const MODULE = 'cancelNotification';

// ----------------- API ENDPOINTS ---------------------------
export const API_CANCEL_NOTIFICATION_SIGNUP_POST = { method: 'POST', url: '/api/guest/cancel-notification' }
export const API_CANCEL_NOTIFICATION_SIGNUP_DELETE = { method: 'DELETE', url: '/api/guest/cancel-notification' }

// ----------------- ACTION TYPES ---------------------------
const signUp = 'signUp';
export const doSignUp = MODULE + '/' + signUp;
const signDown = 'signDown';
export const doSignDown = MODULE + '/' + signDown;

// ----------------- MUTATION TYPES ---------------------------
export const SET_CLIENT_SETTINGS = 'SET_CLIENT_SETTINGS';
export const SET_ITEMS = 'SET_ITEMS';
export const ADD = 'ADD';
export const REMOVE = 'REMOVE';

// ----------------- GETTERS ---------------------------
const getClientActive = 'getClientActive';
export const cnGetClientActive = MODULE + '/' + getClientActive;


export default {
  namespaced: true,
  // ===================================================== STATE =====================================================
  state: () => ({
    client: {
      active: false,
    },
    items: [],
  }),

  actions: {
    // -------------------------- subscribe: STARTUP --------------------------------
    setStartUpRaw: {
      root: true,
      handler ({ commit }, body) {

        let client = { active: false }
        if (body.remoteSettings?.cancelNotification) {
          client.active = true;
        }
        commit(SET_CLIENT_SETTINGS, client);
      },
    },

    // -------------------------- subscribe: AFTER FETCH TABLE --------------------------------
    afterFetchTable: {
      root: true,
      // eslint-disable-next-line
      handler ({ commit, dispatch }, body) {
        if (body.hasOwnProperty('cancelNotifications'))
          commit(SET_ITEMS, body.cancelNotifications);
      },
    },


    // -------------------------- SIGN-UP --------------------------------
    [signUp] ({ commit }, data) {
      return api.req(API_CANCEL_NOTIFICATION_SIGNUP_POST, data)
        .then((res) => {
          commit(ADD, data.from_time);
          return res;
        });
    },

    // -------------------------- SIGN-DOWN --------------------------------
    [signDown] ({ commit }, data) {
      return api.req(API_CANCEL_NOTIFICATION_SIGNUP_DELETE, data)
        .then((res) => {
          commit(REMOVE, data.from_time);
          return res;
        });
    },

  }, // actions

  // ===================================================== MUTATIONS =====================================================
  mutations: {
    [SET_CLIENT_SETTINGS] (state, data) {
      state.client = data;
    },
    [SET_ITEMS] (state, data) {
      state.items = data;
    },
    [ADD] (state, from_time) {
      state.items.push(from_time);
    },
    [REMOVE] (state, from_time) {
      let ix = state.items.indexOf(from_time);
      if (ix >= 0)
        state.items.splice(ix, 1);
    },

  }, // mutations

  // ===================================================== GETTERS =====================================================
  getters: {
    // -------------------------- client config --------------------------------
    // eslint-disable-next-line
    [getClientActive]: (state, getters, rootState, rootGetters) => {
      return rootGetters.isLoggedIn && !!(rootGetters.getSelectedClientConfig?.cancelNotification);
    },

  },

}
